import { FC } from 'react'
import { CenterScreenModal } from '../atoms'
import { AddNewMenuCard } from '../organism'
import { useOpeningElementsControllerContext } from '@/customHooks'

export const AddNewMenuModal: FC = () => {
  const { state, addMenuModalClose} = useOpeningElementsControllerContext();
  
  return (
    <CenterScreenModal
      isOpen={state.isAddMenuModalOpen}
      onClose={addMenuModalClose}
    >
      <AddNewMenuCard />
    </CenterScreenModal>
  )
}